const PAYMENT_METHOD_ALIASES = {
  PIX: "pix",
  pix: "pix",
  DINHEIRO_ENTREGA: "cash_on_delivery",
  cash_on_delivery: "cash_on_delivery",
  DINHEIRO_BALCAO: "cash_on_delivery",
  cash_at_counter: "cash_on_delivery",
  "Dinheiro na entrega": "cash_on_delivery",
  "Dinheiro no balcão": "cash_on_delivery",
  CARTAO_ENTREGA: "card_on_delivery",
  card_on_delivery: "card_on_delivery",
  CARTAO_BALCAO: "card_on_delivery",
  CARTAO_PIX_BALCAO: "card_on_delivery",
  card_at_counter: "card_on_delivery",
  "Cartão na entrega": "card_on_delivery",
  "Cartão/Pix no balcão": "card_on_delivery",
};

const PAYMENT_METHOD_LABELS = {
  pix: "Pix",
  cash_on_delivery: "Dinheiro na entrega",
  card_on_delivery: "Cartão na entrega",
};

export function normalizePaymentMethod(method) {
  return PAYMENT_METHOD_ALIASES[String(method || "")] || method || null;
}

export function paymentMethodLabel(method, fulfillmentMode = null) {
  const normalized = normalizePaymentMethod(method);
  const pickup = ["pickup", "retirada", "retirar"].includes(
    String(fulfillmentMode || "").toLowerCase()
  );

  if (pickup) {
    if (normalized === "cash_on_delivery") {
      return "Dinheiro no balcão";
    }

    if (normalized === "card_on_delivery") {
      return "Cartão/Pix no balcão";
    }
  }

  return PAYMENT_METHOD_LABELS[normalized] || normalized || "-";
}

export function isPixPayment(payment) {
  return normalizePaymentMethod(payment && payment.metodo) === "pix";
}

export function isDeliveryCollectionPayment(payment) {
  return ["cash_on_delivery", "card_on_delivery"].includes(
    normalizePaymentMethod(payment && payment.metodo)
  );
}

export function normalizePayment(payment) {
  if (!payment || typeof payment !== "object") {
    return {};
  }

  return {
    ...payment,
    metodo: normalizePaymentMethod(payment.metodo),
  };
}

export function isMissingEndpointError(error) {
  const status = error && error.response ? error.response.status : null;
  const data = error?.response?.data;
  const message = String(
    typeof data === "string"
      ? data
      : data?.msg || data?.message || data?.error || ""
  );
  // Durante um reload gradual do Swoole, a tabela de rotas antiga pode
  // interpretar `/quadro` ou `/historico` como `{id}` e responder a mensagem
  // abaixo com 400/422. Trate essa colisão como endpoint legado para que o
  // painel use o adaptador antigo até o processo novo assumir.
  const legacyDynamicRouteCollision =
    [400, 422].includes(status) &&
    /pedido online n[aã]o encontrado/i.test(message);

  return status === 404 || status === 405 || legacyDynamicRouteCollision;
}
